import React from 'react';
import {Link} from 'react-router-dom';
import {mainUrl, urlsImg} from '@/pages/configPages';

import s from './PageNotFound.module.css';

const PageNotFound = () => (
    <div className={s.decoration}>
        <div>
    				<img src={urlsImg.pageNotFound} alt="404" className={s.img} />
    				<div className={s.content}>
        					<h1 className={s.title}>Страница <br />не найдена</h1>
        					<p className={s.text}>
            						Такого у нас нет, но есть много интересного
            						<br />
                        <Link to={mainUrl} className={s.link}>На главную</Link>
        					</p>
    				</div>
        </div>
    </div>
);

export default PageNotFound;
